import { request } from '../utils/request';
import qs from 'qs';


// 获取列表数据
export async function getListData(current, pagesize) {
  return request(`/project/selectAll?${qs.stringify({
    pageNum: current,
    pageSize: pagesize, k: (new Date()).getTime()
  })}`);
}
// 枚举
export async function enumerationData() {
  return request('/project/selectDictMaps');
}

//行业领域
export async function domains() {
  return request('/dict/domains');
}

//投融资首页资讯列表
export async function selectBlogList() {
  return request('/api/invest/selectBlogList');
}
//投融资首页查询项目列表
export async function selectGoldProject(data) {
  return request(`/api/invest/selectGoldProjectList?${qs.stringify(data)}`);
}
//投融资首页查询投融资事件列表
export async function selectProjectFiance(data) {
  return request(`/api/invest/selectProjectFiance?${qs.stringify(data)}`);
}

//投融资标签查询项目列表
export async function selectProjectByTag(data) {
  return request(`/api/invest/selectProjectByDomain?${qs.stringify(data)}`);
}

// 列表提交
// export async function listSubmitData(key) {
//     let api =`/project/commitByList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`,
//       id = {id:key};
//     return request( api, {
//       method:'POST',
//       body:qs.stringify(id)
//     });
//   }


export async function getDoamins() {
  return request('/api/invest/getDoamins');
}


export async function projectClaim(data) {
  const api = `/api/invest/updateGoldProjectInfo?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
}


// WEBPACK FOOTER //
// ./src/scripts/services/finance.js